import React, { useContext } from 'react';
import Auxiliary from '../../../util/Auxiliary';
import { Formik, Form } from 'formik';
import { Row, Col, Button, Card, message } from 'antd';
import { Link, useHistory } from 'react-router-dom';
import Item from '../../../components/Form/Item';
import PassportSelect from '../../Training/Form/PassportSelect';
import PassportDetail from '../../Training/Form/PassportDetail';
import Detail from './Detail';
import { newViolationSchema } from './schema';
import axios from '../../../util/Api';
import { ParamsContext } from '../../Context/ParamsContext';
import Scan from './Scan';

const Index = () => {
  const history = useHistory();
  const { id } = useContext(ParamsContext);

  return (
    <Auxiliary>
      <Formik
        validationSchema={newViolationSchema}
        initialValues={{
          passport: {
            id: id
          },
          date: {
            start: undefined,
            end: undefined
          },
          level: undefined,
          remark: undefined
        }}
        onSubmit={values => {
          const url = `/violation/create`;
          axios.post(url, { ...values }).then(resp => {
            if (resp.data.success) {
              message.success("Data pelanggaran baru telah berhasil disimpan");
              history.push(`/violation`);
            } else {
              message.error("Gagal menyimpan data pelanggaran");
            }
          }).catch(err => {
            console.log(err);
            message.error("Gagal menyimpan data pelanggaran. Silakan reload dan coba kembali");
          });
        }}
      >
        {(formik) => {
          return (
            <Form>
              <Row>
                <Col md={16} xs={24}>
                  <Card className="gx-card">
                    <Item name="Identitas Diri">
                      <PassportSelect />
                    </Item>

                    {formik.values.passport.id ? <PassportDetail /> : null}

                    {formik.values.passport.id ? <Detail /> : null}

                    <Row>
                      <Col span={6}></Col>
                      <Col span={18}>
                        <Button type="primary" htmlType="submit" loading={formik.isSubmitting}>Simpan Data Pelanggaran</Button>
                        <Link to={id ? `/passport/detail?id=${id}` : `/violation`}><Button type="default">Batal</Button></Link>
                      </Col>
                    </Row>

                  </Card>
                </Col>
                <Col md={8} xs={24}>
                  <Scan />
                </Col>
              </Row>
            </Form>
          );
        }}
      </Formik>
    </Auxiliary>
  );
}

export default Index;